import React, { memo, useMemo } from "react";
import { IconButton, Link, Tooltip } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import config from "../../../../shared/api/config";

function ExportGeoZone() {
  const paramsString = useMemo(() => {
    const token = window.localStorage.getItem('token') || window.sessionStorage.getItem('token');

    const params = {
      access_token: token,
    };

    return new URLSearchParams(params).toString();
  }, []);

  return (
    <Link
      href={`${config.baseUrl}/geo-zones/export?${paramsString}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Tooltip title="Экспорт геозон">
        <span>
          <IconButton>
            <FileDownloadIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Link>
  );
}

export default memo(ExportGeoZone);
